.icon-comment,.icon-comment .icon-wrapper{position:relative}.icon-comment .icon-wrapper .top-right-icon{font-size:7px;position:absolute;top:0;right:-2px;color:#258cfd}
/*# sourceMappingURL=appscripts-user-table-actions.component-KZQFWW6Q.css.map */
